import { BrazilDate } from "../../../utils/BrazilDate";
import type { AguardandoEntregaItem } from "../../../services/aguardandoEntregaService";

export const formatAguardandoEntregaOrderLabel = (
  displayId: number,
  orderId: number
) => `#${displayId} (${orderId})`;

export const formatAguardandoEntregaDateTime = (iso: string) => {
  try {
    return BrazilDate.formatBR(new Date(iso), true);
  } catch {
    return iso;
  }
};

export const buildAguardandoEntregaTableRows = (
  items: AguardandoEntregaItem[]
) =>
  items.map((item) => [
    formatAguardandoEntregaOrderLabel(item.displayId, item.orderId),
    item.montador.nome,
    formatAguardandoEntregaDateTime(item.dataInicio),
    item.pedidoIntegracao?.customerName ?? "-",
    item.observacao ?? item.pedidoIntegracao?.observation ?? "-",
  ]);
